module.exports = __webpack_public_path__ + "static/media/arrow_right_circle.5b969fce.svg";